export enum ProfileRecordStatus {
  NEW = 'NW',
  CREATE = 'CR',
  ACTIVE = 'AC',
  DELETE = 'DL',
  HOLD = 'HD'
}
